
interface LocaleType {
  [key:string]: any
}

const en_US:LocaleType = {
  copy: {
    successMessage: 'Successfully Copied'
  },
  cleanUp: 'clean up',
  noData: 'no Data',
  total: 'Total',
  item: 'item',
  customListFields: 'Custom List Fields',
  selectItem: 'Please select the listing details you want to display. You have checked ',
}

export default en_US